import { Job } from './Job';

export class TiffBatchJob extends Job {
  constructor(percentageComplete: number) {
    super();
    this.percentageComplete = percentageComplete;
  }
}
